import * as React from "react";
import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import { app, authentication } from "@microsoft/teams-js";

export const SuccessSSo = () => {
  const history = useHistory();
  const { token, language } = useParams();
  useEffect(() => {
    const url = window.location.href;
    const accessToken = url.split("/success/")[1].split("/")[0];
    const lang = url.split("/success/")[1].split("/")[1];
    localStorage.setItem("appToken", accessToken);
    localStorage.setItem("lang", lang);
    app.initialize().then(() => {      
      authentication.notifySuccess(
          JSON.stringify({
              token: accessToken,
              locUrl: window.location.href,
              host: localStorage.getItem("host"),
              context: localStorage.getItem("context"),
          })
      );
    }).catch(error => {
        console.error("Teams SDK Initialization Failed:", error);
    });
  });

  return <div>Success!!!</div>;
};
